<template>
  <div class="sidebar-cart-item">
    <a :href="productUrl" class="product-image">
      <img
        :src="getBaseImage"
        :class="{ 'image-placeholder': ! hasBaseImage }"
        alt="product image"
        @error="handleImageError"
      >
    </a>

    <div class="product-info">
      <a :href="productUrl" class="product-name" :title="cartItem.product.name">
        {{ cartItem.product.name }}
      </a>

      <ul class="list-inline product-options">
        <li v-for="option in cartItem.options" :key="option.id">
          <label>{{ option.name }}:</label> {{ optionValues(option) }}
        </li>
      </ul>

      <b-overlay
        :show="apiLoading"
        spinner-variant="primary"
        blur=".3"
        opacity=".75"
        rounded="sm">
        <div class="product-quantity">
          $<span v-html="currencyFormat(cartItem.unitPrice.inCurrentCurrency.formatted, 0, 2)"></span> x
          {{ currencyFormat(cartItem.qty, 0, 0) }} = <span
          class="total_price">${{ currencyFormat(cartItem.total.inCurrentCurrency.formatted, 0, 2)
          }} </span>

          <span class="d-flex" v-if="cartItem.product_variant_serial_number">
            Serial Number: &nbsp; <strong>{{ cartItem.product_variant_serial_number }}</strong>
          </span>
        </div>
      </b-overlay>
    </div>

    <div class="remove-cart-item">
      <button class="btn-remove" @click="remove">
        <i class="las la-times"></i>
      </button>
    </div>

  </div>
</template>

<script>
import ProductCardMixin from "../../mixins/ProductCardMixin"
import DefaultImageMixin from "@core/mixin/DefaultImageMixin"
import { currencyFormat } from "../../functions"
import store from "../../store"

export default {
  mixins: [
    ProductCardMixin,
    DefaultImageMixin
  ],
  props: ["cartItem"],
  computed: {
    product() {
      return this.cartItem.product
    }
  },
  data() {
    return {
      currencyFormat
    }
  },
  methods: {
    optionValues(option) {
      let values = []
      for (let value of option.values) {
        values.push(value.label)
      }
      return values.join(", ")
    },
    remove() {
      store.removeCartItem(this.cartItem)

      $.ajax({
        method: "DELETE",
        url: route("cart.items.destroy", { cartItemId: this.cartItem.id })
      }).then((cart) => {
        store.updateCart(cart)
      })
    },
    handleImageError(event) {
      // Handle the image loading error by replacing the image source with the default image source
      event.target.src = this.defaultImage
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

.las, .lar {
  font-size: 23px;
}

.number-picker {
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 50%;
  height: 40px;
}

.number-picker label {
  font-weight: 500;
  margin-bottom: 0;
}

.number-picker .input-quantity {
  padding: 10px 39px 10px 10px;
  height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.number-picker .input-quantity:focus {
  outline: 0;
  border-color: #ebebeb;
}

.number-picker .btn-wrapper {
  position: absolute;
  top: 0;
  right: 0;
}

.number-picker .btn-wrapper .btn-number {
  cursor: pointer;
  position: absolute;
  right: 0;
  width: 30px;
  padding: 0;
  line-height: 18px;
  background: none;
  border: 1px solid #ebebeb;
  border-radius: 0;
}

.number-picker .btn-wrapper .btn-number:hover {
  color: #DEAA5E;
}

.number-picker .btn-wrapper .btn-number[disabled]:hover {
  color: #191919;
}

.number-picker .btn-wrapper .btn-plus {
  top: 0;
  color: #DEAA5E;
  height: 20px;
  border-top-right-radius: 2px;
  border-bottom: 1px solid #ebebeb;
  border-left: 1px solid #ebebeb;
}

.number-picker .btn-wrapper .btn-minus {
  top: 20px;
  height: 20px;
  border-bottom-right-radius: 2px;
  border-left: 1px solid #ebebeb;
}

.btn-add-to-cart {
  padding: 10px;
  width: 50%;
  line-height: 20px;
  border-radius: 4px;
  font-size: 14px;
}

.rating {
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.text-muted {
  color: #B5B5B5 !important;
}

</style>
